export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; allowedRoles?: string[] }
  children?: INavigationRoute[]
}

const filterRoutesByRole = (routes: INavigationRoute[], role: string): INavigationRoute[] => {
  return routes
    .filter((route) => {
      if (route.meta.allowedRoles && route.meta.allowedRoles.includes(role)) {
        return true
      }
      if (!route.meta.allowedRoles) {
        return true
      }
      return false
    })
    .map((route) => {
      if (route.children) {
        route.children = filterRoutesByRole(route.children, role)
      }
      return route
    })
}

const sidebarRoutes = {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'Analytics Dashboard',
      meta: {
        icon: 'dashboard',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'dashboard',
          displayName: 'Overview',
          meta: {
            icon: 'overview',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'analytics',
          displayName: 'Analytics',
          meta: {
            icon: 'analytics',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'reports',
      displayName: 'Reports',
      meta: {
        icon: 'assessment',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'reports',
          displayName: 'All Reports',
          meta: {
            icon: 'assessment',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'driver-reports',
          displayName: 'Driver Reports',
          meta: {
            icon: 'moped',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'financial-reports',
          displayName: 'Financial Reports',
          meta: {
            icon: 'account_balance',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'odometer-reports',
          displayName: 'Odometer Reports',
          meta: {
            icon: 'speed',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'charging-reports',
          displayName: 'Charging Reports',
          meta: {
            icon: 'battery_charging_full',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'fleet-analytics',
      displayName: 'Fleet Analytics',
      meta: {
        icon: 'commute',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'drivers',
          displayName: 'Driver Analytics',
          meta: {
            icon: 'moped',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'our-drivers',
          displayName: 'Our Drivers',
          meta: {
            icon: 'person',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'vehicles',
          displayName: 'Vehicle Analytics',
          meta: {
            icon: 'directions_car',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'our-vehicles',
          displayName: 'Our Vehicles',
          meta: {
            icon: 'directions_car',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'bikes',
          displayName: 'Bikes',
          meta: {
            icon: 'two_wheeler',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'trips',
          displayName: 'Trip Analytics',
          meta: {
            icon: 'route',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'performance',
      displayName: 'Performance Metrics',
      meta: {
        icon: 'trending_up',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'performance',
          displayName: 'Performance Dashboard',
          meta: {
            icon: 'dashboard',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'scorecard',
          displayName: 'Scorecard',
          meta: {
            icon: 'score',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'esg-reports',
      displayName: 'ESG Reports',
      meta: {
        icon: 'eco',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'ev-dashboard',
          displayName: 'EV Dashboard',
          meta: {
            icon: 'electric_car',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'impact-reports',
          displayName: 'Impact Reports',
          meta: {
            icon: 'nature',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'marketing',
      displayName: 'Marketing Analytics',
      meta: {
        icon: 'campaign',
        allowedRoles: ['analyst'],
      },
      children: [
        {
          name: 'growth-metrics',
          displayName: 'Growth Metrics',
          meta: {
            icon: 'trending_up',
            allowedRoles: ['analyst'],
          },
        },
        {
          name: 'regional-stats',
          displayName: 'Regional Stats',
          meta: {
            icon: 'location_on',
            allowedRoles: ['analyst'],
          },
        },
      ],
    },
    {
      name: 'preferences',
      displayName: 'Profile',
      meta: {
        icon: 'manage_accounts',
        allowedRoles: ['analyst'],
      },
    },
  ],
}

export default sidebarRoutes
